import { render, staticRenderFns } from "./LBadge.vue?vue&type=template&id=573501a3"
import script from "./LBadge.vue?vue&type=script&lang=js"
export * from "./LBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports